import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { AttachMoneyOutlined } from '@mui/icons-material';
import { SectionHeaderWithCommand, SectionPaper } from '../../../../common/components';
import { LaborCostEditor, PartsCostEditor, VendorCostEditor, TotalCostEditor, CostNotesEditor } from '../fields/cost';
import { FacilityMaintenanceEstimatedCostEditor } from '../fields/facilityMaintenance';

/**
 * CostSection - Section for tracking labor, parts, and vendor costs.
 * Shared between PM (Preventive Maintenance) and FAC (Facility Maintenance) tickets.
 */
export const CostSection: React.FC = () => {
  return (
    <Box>
      <SectionHeaderWithCommand
        icon={<AttachMoneyOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Cost Tracking"
      />

      <SectionPaper>
        <Stack spacing={3}>
          {/* Row 1: Estimated Cost + Actual Cost (computed) */}
          <Box>
            <Typography
              variant="body2"
              sx={{ mb: 1, fontWeight: 500, color: '#64748b' }}
            >
              Summary
            </Typography>
            <Stack direction="row" spacing={2}>
              <Box sx={{ flex: 1 }}>
                <FacilityMaintenanceEstimatedCostEditor mode="ticket" />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TotalCostEditor />
              </Box>
            </Stack>
          </Box>

          {/* Row 2: Labor Cost + Parts Cost + Vendor Cost */}
          <Box>
            <Typography
              variant="body2"
              sx={{ mb: 1, fontWeight: 500, color: '#64748b' }}
            >
              Cost Breakdown
            </Typography>
            <Stack direction="row" spacing={2}>
              <LaborCostEditor />
              <PartsCostEditor />
              <VendorCostEditor />
            </Stack>
          </Box>

          {/* Row 3: Cost Notes */}
          <Box>
            <Typography
              variant="body2"
              sx={{ mb: 1, fontWeight: 500, color: '#64748b' }}
            >
              Notes
            </Typography>
            <CostNotesEditor />
          </Box>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default CostSection;
